export class ResetPassword {
    mobileNumber: string;
    newPassword: string;
    confirmPassword: string;
    resetToken: string;
  }